import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getRequirementStudentsAction } from '../actions';

const {
  useLoaderData: useRequirementStudentsData,
  useLoader: useRequirementStudentsLoader,
  LoaderProvider,
} = createLoaderImp({ action: getRequirementStudentsAction });

function RequirementStudentsLoader({
  children,
  ...props
}: Readonly<Parameters<typeof LoaderProvider>[0]>) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  RequirementStudentsLoader,
  useRequirementStudentsData,
  useRequirementStudentsLoader,
};
